import React, {Fragment} from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import {FaSolidIcon} from "../../FontAwesomeIcons";
import {NegozioOpenStore} from "../../../stores/NegozioOpenStore";
import {swalError} from "../../../helpers/SweetAlertWrapper";
import moment from "moment";
import {EcommerceProductStockNotifyButton} from "./EcommerceProductStockNotifyButton";
import ModalPortalHOC from "../../BaseComponents/ModalPortalHOC";
import FuxEvents from "../../../lib/FuxFramework/FuxEvents";
import {
    CTA_ORDER_SUCCESS, ECOMMERCE_GIFT_ORDER_PAID,
    SHOW_BANNER_PARTNERSHIP,
    UPDATE_USER_ORDINI,
    USERS_CONVERSION_PARTNERHIP
} from "../../../const/AppEventsCostants";
import {SHOW_TYPE_PARTNERSHIP_ORDINI_E_COMMERCE} from "../../PartnershipNegozi/PartnershipConstants";
import EcommerceDirectCheckoutFlow from "../EcommerceDirectCheckoutFlow";
import {
    ECOMMERCE_ORDER_TYPE_DEFAULT, ECOMMERCE_PRODUCT_TYPE_GIFT_CARD,
    ECOMMERCE_PRODUCT_TYPE_PACCHETTO, ECOMMERCE_PRODUCT_TYPE_PACCHETTO_SMART,
    ECOMMERCE_PRODUCT_TYPE_VIRTUALE
} from "../../../const/ModuloEcommerceCostants";
import {PageZLayerSelector} from "../../BaseComponents/Page/PageZLayerSelector";
import i18n from "../../../i18n";


export class EcommerceProductDirectBuyView extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            quantita: 1,
            attributi: {}, // => {"attrname"=>[valori disponibili]}
            varianteTemp: {},
            fakeCart: [],
            checkoutOpen: false
        }
        this.props.productData.modelli.map(m => {
            Object.keys(m.variante).map(attrName => {
                //Creo la lista dei possibili valori dell'attributo
                if (!this.state.attributi[attrName]) this.state.attributi[attrName] = [];
                //Se già esiste il valore allora esco
                if (this.state.attributi[attrName].find(value => value === m.variante[attrName])) return;
                //Aggiungo il valore alla lista
                this.state.attributi[attrName].push(m.variante[attrName]);
            })
        });
    }

    handleAppOpen = _ => {
        /**
         * L'obiettivo è far arrivare l'ID prodotto da aprire all'app, salvo i dati prodotto nello Store globale
         * senza l'invio dell'evento e simulo l'apertura di un dynamic link
         * */
        NegozioOpenStore.shouldOpenProduct = this.props.productData;
        this.props.onAppOpen(this.props.productData.id_negozio);
    }

    handleMinusButton = e => {
        const step = this.getQuantityStep();
        this.setState({
            quantita: +(Math.max(step, this.state.quantita - step).toFixed(step.countDecimals()))
        })
    }

    handlePlusButton = e => {
        const step = this.getQuantityStep();
        this.setState({
            quantita: +((Math.min(this.state.quantita + step, this.props.productData.quantita)).toFixed(step.countDecimals()))
        })
    }

    getQuantityStep = _ => {
        switch (this.props.productData.um) {
            case "kg":
                return 0.1;
            default:
                return 1;
        }
    }

    handleOptionChange = (optionData, actionData) => {
        let varianteTemp = {...this.state.varianteTemp}
        if (actionData.action === 'select-option') {
            varianteTemp[actionData.name] = optionData.value;
        }
        if (actionData.action === 'clear') {
            delete varianteTemp[actionData.name];
        }
    }

    shouldOptionDisable = (attrName, value) => {
        //Devo verificare se esiste un modello che ha tutti gli attributi di this.state.varianteTemp U {[attrName]:value}
        const modelli = this.props.productData.modelli.slice();
        const expectedVariante = {...this.state.varianteTemp, [attrName]: value};
        let found = false;
        for (var i in modelli) {
            const m = modelli[i];
            let _localFound = true;
            const realVariante = m.variante;
            Object.keys(expectedVariante).map(attr => {
                if (realVariante[attr] !== expectedVariante[attr]) {
                    _localFound = false;
                }
            });
            if (_localFound) {
                found = true;
                break;
            }
        }
        return !found;
    }

    getCurrentModello = _ => {
        const modelli = this.props.productData.modelli.slice();

        const expectedVariante = {...this.state.varianteTemp};
        let modello = undefined;

        if (modelli.length && Object.keys(expectedVariante).length === Object.keys(modelli[0].variante).length) {
            for (var i in modelli) {
                const m = modelli[i];
                let attributesMatch = true;
                const realVariante = m.variante;
                Object.keys(expectedVariante).map(attr => {
                    if (realVariante[attr] !== expectedVariante[attr]) {
                        attributesMatch = false;
                    }
                });
                if (attributesMatch) {
                    modello = m;
                    break;
                }
            }
        }
        return modello;
    }

    handleCheckoutStart = _ => {
        let attributeList = Object.keys(this.state.attributi);
        for (var i in attributeList) {
            if (!this.state.varianteTemp[attributeList[i]]) {
                swalError(i18n.t('ecommerce.errors.select-all-options-to-buy'));
                return;
            }
        }

        let productCartData = {};
        //Recupero il modello scelto
        if (this.props.productData.modelli.length) {
            const modello = this.getCurrentModello();
            if (!modello) {
                swalError(i18n.t('ecommerce.errors.variant-not-found'));
                return;
            }
            if (!this.getCurrentStock()) {
                swalError(i18n.t('ecommerce.errors.not-in-stock-buy'));
                return;
            }
            productCartData = {
                ...this.props.productData,
                quantita: this.state.quantita,
                variante: modello.variante,
                prezzo: modello.prezzo
            };
        } else {
            productCartData = {...this.props.productData, quantita: this.state.quantita, variante: {}};
        }

        this.setState({
            fakeCart: [productCartData],
            checkoutOpen: true
        });
    }

    handleCheckoutDismiss = _ => {
        this.setState({
            fakeCart: [],
            checkoutOpen: false
        });
    }

    getCurrentStock = _ => {

        if (moment().format('YYYY-MM-DD hh:mm:ss') < this.props.productData.data_disponibilita) {
            return 0;
        }
        if (moment().format('YYYY-MM-DD hh:mm:ss') > this.props.productData.available_until_date) {
            return 0;
        }
        if (this.props.productData.preventivo === "1") {
            return undefined;
        } else if (this.props.productData.modelli.length === 0) {
            return parseFloat(this.props.productData.quantita);
        } else {
            const modello = this.getCurrentModello();
            if (modello) {
                return parseFloat(modello.quantita);
            } else {
                return undefined;
            }
        }

        return 0;
    }

    getStockLabel = _ => {
        const stock = this.getCurrentStock();
        if (stock !== undefined) {
            if (stock === 0) {
                return <span className={"text-danger"}>{i18n.t('ecommerce.availability.unavailable')}</span>
            } else {
                if (parseInt(this.props.productData.ignora_magazzino) === 1 || stock >= 15) {
                    return <span className={"text-success"}>{i18n.t('ecommerce.availability.immediate')}</span>
                } else {
                    return <span
                        className={"text-success"}>{i18n.t('ecommerce.availability.in-stock-template', {stock: stock})}</span>
                }
            }
        }
        return '';
    }

    handlePaymentSuccess = (order_id, isGift = false) => {
        console.log("PAGAMENTO A BUON FINE")
        this.handleCheckoutDismiss();
        FuxEvents.emit(UPDATE_USER_ORDINI);
        FuxEvents.emit(CTA_ORDER_SUCCESS);
        FuxEvents.emit(SHOW_BANNER_PARTNERSHIP, SHOW_TYPE_PARTNERSHIP_ORDINI_E_COMMERCE);
        FuxEvents.emit(USERS_CONVERSION_PARTNERHIP,
            {
                "tipo_operazione": "ordine_e_commerce",
                "id_negozio": NegozioOpenStore.infoNegozio.id_negozio
            });
        //If is a gift and the order is paid emit the event
        if (isGift) FuxEvents.emit(ECOMMERCE_GIFT_ORDER_PAID, {order_id: order_id});
    }

    render() {
        const getShipping = [ECOMMERCE_PRODUCT_TYPE_PACCHETTO, ECOMMERCE_PRODUCT_TYPE_PACCHETTO_SMART, ECOMMERCE_PRODUCT_TYPE_VIRTUALE, ECOMMERCE_PRODUCT_TYPE_GIFT_CARD].indexOf(this.props.productData.ecommerce_type) === -1;

        return (
            <Fragment>
                <div className={"my-3 bg-main-z2 shadow-sm rounded p-3"}>
                    {
                        Object.keys(this.state.attributi).length ? <label>Opzioni disponibili</label> : ''
                    }
                    {
                        Object.keys(this.state.attributi).map((attrName, i) => {
                            return (
                                <div key={i} className={"form-group"}>
                                    <Select
                                        className="basic-single"
                                        classNamePrefix="select"
                                        defaultValue={this.state.attributi[attrName][0]}
                                        isClearable={true}
                                        isSearchable={false}
                                        name={attrName}
                                        placeholder={attrName}
                                        options={this.state.attributi[attrName].map(v => {
                                            return {
                                                value: v,
                                                label: v,
                                                isDisabled: this.shouldOptionDisable(attrName, v)
                                            }
                                        })}
                                        onChange={this.handleOptionChange}
                                    />
                                </div>
                            );
                        })
                    }

                    {
                        !!this.props.onOpenApp &&
                        <button className={"btn btn-block btn-secondary"} onClick={this.handleAppOpen}>
                            <FaSolidIcon name={"tablet"}/> {i18n.t('open-app-btn')}
                        </button>
                    }

                    <div className={"d-flex align-items-center"}>
                        <button className={"btn btn-link text-primary"} onClick={this.handleMinusButton}>
                            <FaSolidIcon name={"minus"}/>
                        </button>
                        <span className={"px-3 py-2 bg-main rounded"}>
                                        {this.state.quantita}
                            {
                                this.props.productData.um === 'pz' ? '' :
                                    <span className={"ml-1"}>{this.props.productData.um}</span>
                            }
                                    </span>
                        <button className={"btn btn-link text-primary"} onClick={this.handlePlusButton}>
                            <FaSolidIcon name={"plus"}/>
                        </button>
                        <div className={"flex-grow-1 ml-3"}>
                            {
                                this.getCurrentStock() !== undefined && this.getCurrentStock() === 0 ?
                                    <EcommerceProductStockNotifyButton
                                        productData={this.props.productData}
                                        modello={this.getCurrentModello()}
                                    />
                                    :
                                    <button className={"btn btn-block btn-secondary"}
                                            onClick={this.handleCheckoutStart}>
                                        <FaSolidIcon name={"shopping-bag"}/> {i18n.t('ecommerce.buy-now-btn')}
                                    </button>
                            }
                        </div>
                    </div>

                    <div className={"small text-center mt-2"}>
                        {this.getStockLabel()}
                    </div>
                </div>

                <ModalPortalHOC>
                    <PageZLayerSelector zIndex={2001}>
                        {
                            this.state.checkoutOpen &&
                            <EcommerceDirectCheckoutFlow
                                orderType={ECOMMERCE_ORDER_TYPE_DEFAULT}
                                allowGiftPurchase={this.props.allowGiftPurchase}
                                products={this.state.fakeCart}
                                paymentMethods={NegozioOpenStore.infoNegozio.impostazioni.metodi_pagamento || []}
                                getShipping={getShipping}
                                getBilling={true}
                                onDismiss={this.handleCheckoutDismiss}
                                onPaymentSuccess={this.handlePaymentSuccess}
                            />
                        }
                    </PageZLayerSelector>
                </ModalPortalHOC>
            </Fragment>
        )
    }

}

EcommerceProductDirectBuyView.propTypes = {
    productData: PropTypes.object.isRequired,
    allowGiftPurchase: PropTypes.bool,
    onAppOpen: PropTypes.func,
}